<div class="centered">
    <label for="lobSelect">
        Line of Business:
    </label>
    <select class="custom-select" [(ngModel)]="lobSelect" (ngModelChange)="group_applyFilter();">
        <option class="custom-option" id="lobSelect" ngValue="" selected>All LOBs</option>
        <option *ngFor="let lob of lobList;" [ngValue]="lob[1]">{{lob[0]}}</option>
    </select>
</div>
<br>

<div class="message-container">
    <app-response-text [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>
</div>
<br>
<!-- <div class="table-container">
    <app-data-grid 
        [(data)]="group_filteredData" 
        [objectBluePrint]="bluePrint" 
        [(isValid)]="formValid"
        [formTemplate]="groupForm" 
        [viewTemplate]="groupView"
        [columnNames]="['Group Name', 'DID', 'Email', 'CC', 'Greeting', 'LOB']" 
        [spacing]="[2, 2, 2, 2, 3, 1, 1]"
        [itemsPerPage]="10" 
        (buttonEvent)="lambdaMessage=''; lambdaError=false; group_handleButtonEvent($event);"
        (itemChange)="group_handleItemChange($event);">

        <ng-template #groupForm let-item>
            <td>
                <input type="text" class="left-text" [(ngModel)]="item.groupName"(ngModelChange)="formValid = group_validate(item);" placeholder="Group Name...">
            </td>
            <td>
                <app-combo-box 
                    [(value)]="item.DID"
                    (valueChange)="setExtension($event, item); formValid = group_validate(item);"
                    [options]="didOptions" 
                    [disabled]="modeIsEdit">
                </app-combo-box>
            </td>
            <td>
                <input type="text" class="left-text" [(ngModel)]="item.emailAddress" (ngModelChange)="formValid = group_validate(item);" placeholder="Email...">
            </td>
            <td>
                <input type="text" class="left-text" [(ngModel)]="item.cc" (ngModelChange)="formValid = group_validate(item);" placeholder="CC...">
            </td>
            <td>
                <textarea 
                    class="uk-width-expand uk-textarea left-text edit-text" 
                    [(ngModel)]="item.greeting"
                    (ngModelChange)="formValid = group_validate(item);"
                    placeholder="Voicemail Greeting...">
                </textarea>
            </td>
            <td>
                <select class="custom-select" [(ngModel)]="item.LOB" (ngModelChange)="formValid = group_validate(item);">
                    <option class="custom-option" id="lobSelect" ngValue="" selected hidden>Select LOB</option>
                    <option *ngFor="let lob of lobList;" [ngValue]="lob[1]">{{lob[0]}}</option>
                </select>
            </td>
        </ng-template>

        <ng-template #groupView let-item>
            <td>{{item.groupName}}</td>
            <td>{{item.DID}}</td>
            <td>{{item.emailAddress}}</td>
            <td>{{item.cc}}</td>
            <td>
                <div class="overflow-container">
                    {{item.greeting}}
                </div>
            </td>
            <td *ngIf="item.hasOwnProperty('LOB');">{{item.LOB}}</td>
            <td *ngIf="!item.hasOwnProperty('LOB');">undefined</td>
        </ng-template>

    </app-data-grid>
</div> -->
    
<div fxLayout="row" fxLayoutAlign="center"> 
    <app-mat-data-grid 
        class="page-data-grid"
        [formValid]="formValid"
        [(dataSource)]="group_filteredData" 
        [displayedColumns]="['groupName', 'DID', 'emailAddress', 'cc', 'greeting', 'LOB']"   
        [columnNames]="['Group Name', 'DID', 'Email', 'CC', 'Greeting', 'LOB']" 
        [editDefinition]="{'groupName': group, 'DID': did, 'emailAddress': email, 'cc': cc, 'greeting': greeting, 'LOB':lob}"
        [pageSizeOptions] = "[5, 10, 15]"
        [buttonConfig]="{create: {show: true}}"
        [objectBluePrint]="bluePrint"
        (buttonClick)="group_handleItemChange($event)">
    </app-mat-data-grid>
</div>

<ng-template #group let-element>
    <input type="text" class="left-text" [(ngModel)]="element.groupName"(ngModelChange)="formValid = group_validate(element);" placeholder="Group Name...">
</ng-template>

<ng-template #did let-element>
    <app-combo-box 
        [(value)]="element.DID"
        (valueChange)="setExtension($event, element); formValid = group_validate(element);"
        [options]="didOptions" 
        [disabled]="modeIsEdit">
    </app-combo-box>
</ng-template>

<ng-template #email let-element>
    <input type="text" class="left-text" [(ngModel)]="element.emailAddress" (ngModelChange)="formValid = group_validate(element);" placeholder="Email...">
</ng-template>

<ng-template #cc let-element>
    <input type="text" class="left-text" [(ngModel)]="element.cc" (ngModelChange)="formValid = group_validate(element);" placeholder="CC...">
</ng-template>

<ng-template #greeting let-element>
    <textarea 
        class="uk-width-expand uk-textarea left-text edit-text" 
        [(ngModel)]="element.greeting"
        (ngModelChange)="formValid = group_validate(element);"
        placeholder="Voicemail Greeting...">
    </textarea>
</ng-template>

<ng-template #lob let-element>
    <select class="custom-select" [(ngModel)]="element.LOB" (ngModelChange)="formValid = group_validate(element);">
        <option class="custom-option" id="lobSelect" ngValue="" selected hidden>Select LOB</option>
        <option *ngFor="let lob of lobList;" [ngValue]="lob[1]">{{lob[0]}}</option>
    </select>
</ng-template>

<a id="downloadLink" hidden></a>